export default __webpack_public_path__ + "static/media/fullstack-development-selected.67dd0391.svg";